import { useNavigate } from 'react-router-dom';
import { CharacterCardClickEvent } from '~/components/common/CharacterCard/CharacterCard';
import { useCheckExistenceMutation } from '~/features/chatRoom';
import { CheckChatRoomExistenceRequest } from '~/types';
import { GAEvent } from '~/utils';
import { GA, PAGE_ROUTE } from '~/constants';
import { useUserStore } from '~/store';
import useChatPageLoadingStatus from '~/store/useChatPageLoadingStatusStore';
import useToast from '~/store/useToast';

const useCreateChatRoom = () => {
  const navigate = useNavigate();
  const email = useUserStore((state) => state.email);
  const { showToast } = useToast();

  const { mutate: existenceMutate, isPending: isExistencePending } =
    useCheckExistenceMutation();

  const { setChatPageLoadingStart, setChatPageLoadingEnd, isChatPageLoading } =
    useChatPageLoadingStatus();

  const handleCreateRoomClick = async ({
    id,
    name = '',
    desc = '',
    type,
    image,
  }: CharacterCardClickEvent) => {
    const request: CheckChatRoomExistenceRequest = {
      character_id: id,
    };
    existenceMutate(request, {
      onSuccess: ({ data, status }) => {
        const { is_existence, chatroom_id } = data;
        // send GA event : CLICK_JOIN_CHAT
        const isNormalChat = !!name && type !== 'mission' && type !== 'mystery';
        isNormalChat &&
          GAEvent(email, GA.ACTION.CLICK_JOIN_CHAT, {
            chat_id: chatroom_id ?? 'first_join',
            character_name: name,
            tag_line: desc,
          });
        if (is_existence) {
          if (!isChatPageLoading && image) {
            setChatPageLoadingStart(image);
          }
          if (type === 'mystery') {
            navigate(`${PAGE_ROUTE.MYSTERY}/${chatroom_id}`);
          } else if (type === 'concept') {
            navigate(`${PAGE_ROUTE.CHAT_CONCEPT}/${chatroom_id}`);
          } else {
            navigate(`${PAGE_ROUTE.CHAT}/${chatroom_id}`);
          }
        } else {
          navigate(`${PAGE_ROUTE.CHARACTER_DETAILS}/${id}`, {
            state: { fromChatRoom: false, type },
          });
        }
      },
      onError: (error) => {
        setChatPageLoadingEnd();
      },
    });
  };

  return {
    handleCreateRoomClick,
    isCreateRoomPending: isExistencePending,
  };
};

export default useCreateChatRoom;
